export let breakpointTab = 768;
export let breakpointPc = 1000;

export const imagePath = "/patients/kodomo-tenkan";
